import { DATA_SUMMARY_EMAIL_REGEX, DATA_SUMMARY_URL_REGEX, DATA_SUMMARY_TEL_REGEX } from '../../../constants';
function getLinkBasedOnValue(value) {
  if (DATA_SUMMARY_EMAIL_REGEX.test(value)) {
    return `mailto:${value}`;
  }
  if (DATA_SUMMARY_URL_REGEX.test(value)) {
    return value;
  }
  if (DATA_SUMMARY_TEL_REGEX.test(value)) {
    return `tel:${value}`;
  }
  return '';
}
export default getLinkBasedOnValue;
//# sourceMappingURL=get-link-based-on-value.js.map